export default "__VITE_ASSET__BSzPbAhW__"